import { Building2, Mail, MapPin, Phone } from "lucide-react";

export default function Impressum() {
  return (
    <section id="impressum" className="py-20 bg-white border-t border-gray-100">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-10">
          <span className="inline-flex items-center rounded-full bg-slate-100 px-4 py-1.5 text-sm font-medium text-slate-700">
            Legal
          </span>
          <h2 className="mt-4 text-3xl md:text-4xl font-bold text-brand-blue">
            Impressum
          </h2>
          <p className="mt-3 text-gray-600 max-w-3xl">
            Angaben gemäß den gesetzlichen Informationspflichten für digitale Dienste.
          </p>
        </div>

        <div className="rounded-3xl border border-gray-200 bg-white shadow-sm overflow-hidden">
          <div className="grid grid-cols-1 lg:grid-cols-3">
            <div className="bg-slate-950 text-white p-8">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 rounded-2xl bg-white/10 flex items-center justify-center">
                  <Building2 className="w-6 h-6" />
                </div>
                <div>
                  <p className="text-xs uppercase tracking-[0.2em] text-slate-400">
                    Anbieter
                  </p>
                  <p className="text-lg font-semibold">FUM DA HANDELS GMBH</p>
                </div>
              </div>

              <div className="space-y-4 text-sm text-slate-300">
                <div className="flex items-start gap-3">
                  <MapPin className="w-4 h-4 mt-0.5 shrink-0" />
                  <div>
                    Wöhlerstraße 8
                    <br />
                    22113 Hamburg
                    <br />
                    Deutschland
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <Mail className="w-4 h-4 mt-0.5 shrink-0" />
                  <a href="mailto:info@fumda.de" className="hover:text-white transition">
                    info@fumda.de
                  </a>
                </div>

                <div className="flex items-start gap-3">
                  <Phone className="w-4 h-4 mt-0.5 shrink-0" />
                  <a href="tel:+49407310510" className="hover:text-white transition">
                    +49 40 7310510
                  </a>
                </div>
              </div>
            </div>

            <div className="lg:col-span-2 p-8 md:p-10">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                <div>
                  <h3 className="text-sm font-semibold uppercase tracking-[0.18em] text-slate-400 mb-3">
                    Unternehmensdaten
                  </h3>
                  <div className="space-y-3 text-sm text-gray-700 leading-6">
                    <p>
                      <span className="font-semibold text-gray-900">Firma:</span>{" "}
                      FUM DA HANDELS GMBH
                    </p>
                    <p>
                      <span className="font-semibold text-gray-900">Rechtsform:</span>{" "}
                      GmbH
                    </p>
                    <p>
                      <span className="font-semibold text-gray-900">Sitz:</span>{" "}
                      Hamburg, Deutschland
                    </p>
                    <p>
                      <span className="font-semibold text-gray-900">Geschäftsführung:</span>{" "}
                      Chia Hui Hsieh
                    </p>
                  </div>
                </div>

                <div>
                  <h3 className="text-sm font-semibold uppercase tracking-[0.18em] text-slate-400 mb-3">
                    Register & Steuern
                  </h3>
                  <div className="space-y-3 text-sm text-gray-700 leading-6">
                    <p>
                      <span className="font-semibold text-gray-900">
                        Handelsregister:
                      </span>{" "}
                      HRB 52915
                    </p>
                    <p>
                      <span className="font-semibold text-gray-900">
                        Registergericht:
                      </span>{" "}
                      Amtsgericht Hamburg
                    </p>
                    <p>
                      <span className="font-semibold text-gray-900">
                        USt-IdNr.:
                      </span>{" "}
                      DE 811459512
                    </p>
                  </div>
                </div>
              </div>

              <div className="mt-10 pt-8 border-t border-gray-200">
                <h3 className="text-sm font-semibold uppercase tracking-[0.18em] text-slate-400 mb-3">
                  Inhaltlich verantwortlich
                </h3>
                <p className="text-sm text-gray-700 leading-6">
                  Verantwortlich für den Inhalt dieser Website gemäß den
                  gesetzlichen Bestimmungen:
                  <br />
                  FUM DA HANDELS GMBH
                  <br />
                  Wöhlerstraße 8, 22113 Hamburg, Deutschland
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
